import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import CommissionSettings from 'containers/settings/commission-settings/CommissionSettings';
import { useAppSelector } from 'hooks';
import React, { FC } from 'react';

const CommissionSettingsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);

  return isActionsBlocked ? <MerchantOrTeamBlockedInfo title="Commission Settings" /> : <CommissionSettings />;
};

export default CommissionSettingsPage;
